export function changesAfter(store, version) {
  return Object.keys(store.state.customerChanges).map(id => store.state.customerChanges[id])
    .filter(change => change.version > version)
}

export function patchCustomers(rows, changes) {
  const known = {}
  changes.forEach(change => { known[change.id] = change })
  return rows.map(row => known[row.id] && known[row.id].info ? Object.assign({}, row, known[row.id].info) : row)
}

export async function syncCustomers(api, endpoint, params, rows, changes) {
  const matching = {}
  const affected = {}
  let total = null
  changes.forEach(change => { affected[change.id] = true })
  for (let offset = 0; offset < changes.length; offset += 100) {
    const response = await api.post(endpoint, Object.assign({}, params, { sync_ids: changes.slice(offset, offset + 100).map(change => change.id) }))
    if (!response || !Array.isArray(response.data) || !response.meta || !response.meta.sync) throw new Error('客户已保存，列表状态暂未同步，请重试同步')
    response.data.forEach(row => { matching[row.id] = row })
    total = response.meta.sync.total
  }
  return {
    list: rows.filter(row => !affected[row.id] || matching[row.id]).map(row => matching[row.id] ? Object.assign({}, row, matching[row.id]) : row),
    total,
    removed: rows.filter(row => affected[row.id] && !matching[row.id]).map(row => row.id)
  }
}

export function capturePosition() {
  const top = document.querySelector('.list-filters')
  const edge = top ? top.getBoundingClientRect().bottom : 64
  const anchors = []
  Array.prototype.forEach.call(document.querySelectorAll('[data-customer-id]'), node => {
    const rect = node.getBoundingClientRect()
    if (rect.bottom > edge && anchors.length < 6) anchors.push({ id: node.getAttribute('data-customer-id'), top: rect.top })
  })
  return { scroll: window.scrollY, anchors }
}

export function restorePosition(vm, position) {
  if (!position) return
  vm.$nextTick(() => {
    window.requestAnimationFrame(() => {
      if (vm._isDestroyed) return
      window.scrollTo(0, position.scroll || 0)
      const anchor = (position.anchors || []).find(item => document.querySelector('[data-customer-id="' + Number(item.id) + '"]'))
      if (anchor) {
        const node = document.querySelector('[data-customer-id="' + Number(anchor.id) + '"]')
        window.scrollBy(0, node.getBoundingClientRect().top - anchor.top)
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/common/customer-sync.js